import { type RootState } from '@/state';

export const isModalOpen = ({ modal: { isModalOpen } }: RootState) =>
  isModalOpen;
export const modalType = ({ modal: { modalType } }: RootState) => modalType;
export const modalData = ({ modal: { modalData } }: RootState) => modalData;
